<template>
  <div class="tg-panel--wrapper">
    <div class="tg-panel--title">{{title}}</div>
    <div class="tg-panel--container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>